import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  getParameterByName(name: string, url?: string) {
    if (!url) {
      url = window.location.href;
    }
    //eslint-disable-next-line
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  parseJWT(token: string): unknown {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  }

  isNotExpired(expiry: string | undefined): boolean {
    if (!expiry) return true;
    const expiryTime = new Date(expiry).getTime();
    if (Number.isNaN(expiryTime)) return true;
    return expiryTime >= Date.now();
  }
}
